import { render, staticRenderFns } from "./CreativeClassify.vue?vue&type=template&id=67258731&scoped=true&"
import script from "./CreativeClassify.vue?vue&type=script&lang=js&"
export * from "./CreativeClassify.vue?vue&type=script&lang=js&"
import style0 from "./CreativeClassify.vue?vue&type=style&index=0&id=67258731&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67258731",
  null
  
)

export default component.exports